const DescriptionFieldTemplate = () => null;

export { DescriptionFieldTemplate };
